// Hooks
import { useTrackViews, AnalyticsTargetType } from 'hooks/analytics';
// Ui
import Input from 'ui3/Input/Input';
import Button from 'ui3/Button/Button';
// Components
import { showToast } from 'components/common/Toast/Toast';
// Styles
import styles from './CopyLink.module.scss';

type CopyLinkProps = {
  name: string;
  label: string;
  link: string;
  /** When set, link copy will send V_C (link copy) for this source. */
  trackSourceId?: string;
  trackTargetType?: AnalyticsTargetType;
  buttonSubVariant?: 'text' | 'outlined';
};

const CopyLink = ({
  name,
  label,
  link,
  trackSourceId,
  trackTargetType = AnalyticsTargetType.PROFILE,
  buttonSubVariant = 'text',
}: CopyLinkProps) => {
  const trackViews = useTrackViews({ targetType: trackTargetType });

  const handleCopyLinkButtonClick = async () => {
    try {
      await navigator.clipboard.writeText(link);

      if (trackSourceId) {
        await trackViews.trackLinkCopy(trackSourceId);
      }

      showToast({
        message: 'Copied',
        autoClose: 1000,
      });
    } catch (error) {
      showToast({
        message: 'Could not copy text',
        type: 'error',
        autoClose: 1000,
      });
    }
  };

  return (
    <div className={styles.root}>
      <Input
        className={styles.input}
        label={label}
        name={name}
        aria-label={label}
        readOnly
        value={link}
      />

      <Button
        aria-label={`Copy ${name} link`}
        variant="secondary"
        subVariant={buttonSubVariant}
        icon="copy"
        onClick={handleCopyLinkButtonClick}
        className={styles.button}
      />
    </div>
  );
};

export default CopyLink;
